import { COHORT_LIST_FAILURE, COHORT_LIST_SUCCESS, CREATE_COHORT_FAILURE, CREATE_COHORT_SUCCESS, TEACHER_DETAILS_FAILURE, TEACHER_DETAILS_SUCCESS } from "./cohort.actionTypes";

const initialState = {
  cohortListTeacher: null,
  teacherDetails: null,
  message: null
};

export default function CohortReducer(state = initialState, { type, payload }) {
  switch (type) {
    case TEACHER_DETAILS_SUCCESS:
      return {
        ...state,
        teacherDetails: payload,
      };
    case TEACHER_DETAILS_FAILURE:
      return {
        ...state,
        message: "",
      };

    // case CREATE_COHORT_SUCCESS:
    //   return {
    //     ...state,
    //     cohortList: payload.data,
    //   };
    // case CREATE_COHORT_FAILURE:
    //   return {
    //     ...state,
    //     message: payload.message,
    //   };

     case COHORT_LIST_SUCCESS:
      return {
        ...state,
        cohortListTeacher: payload,
      };
    case COHORT_LIST_FAILURE:
      return {
        ...state,
        message: "",
      };

    default:
      return state;
  }
}
